import {configureStore} from '@reduxjs/toolkit';
import mineReducer from './reducers/mineSlice';
import workspaceReducer from './reducers/workspaceSlice';
import settingsReducer from './reducers/settingsSlice';
import uiReducer from './reducers/uiSlice';
import {persistWorkspaceMiddleware} from './middleware/persistWorkspace';

export default function createStore() {
    return configureStore({
        reducer: {
            mine: mineReducer,
            workspace: workspaceReducer,
            settings: settingsReducer,
            ui: uiReducer,
        },
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: {
                    ignoredActions: [],
                    ignoredPaths: [],
                },
            }).prepend(persistWorkspaceMiddleware.middleware),
        devTools: process.env.NODE_ENV !== 'production',
    });
}
